export default theme => {
    return {}
}



// WEBPACK FOOTER //
// ./src/app/configuration/FinancialServicesBanking/theme/components/scorecard/MetricsLabels/index.js